// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"cO-z","carouselContainer":"dO-z"};